<template>
    <div>
        <!--        root-->
        <div v-if="root && $vuetify.breakpoint.mdAndUp">
            <v-layout row align-center justify-center>
                <v-flex>
                    <bracket-item
                            :model="model"
                            ref="bracketA"
                            :teams="matchA"
                            :all-teams="allTeams"
                            :for-create="forCreate"
                            :for-manage="forManage"
                            :for-play="forPlay"
                            first-child
                            top/>
                </v-flex>
                <v-flex class="px-4">
                    <v-select
                            v-model="model[value]"
                            :items="options"
                            @change="val => emitSelect(val)"
                            hint="winner"
                            persistent-hint
                            :disabled="forCreate"
                            dense
                    />
                    <!--                            :clearable="forCreate"-->
                    <slot/>
                </v-flex>
                <v-flex>
                    <bracket-item
                            :model="model"
                            ref="bracketB"
                            :teams="matchB"
                            :all-teams="allTeams"
                            :for-create="forCreate"
                            :for-manage="forManage"
                            :for-play="forPlay"
                            reflected
                            first-child
                    />
                </v-flex>
            </v-layout>
        </div>

        <!--        leaf-->
        <v-layout :class="bracketClass" align-center v-else-if="teams.length === 1">
            <!--            create-->
            <v-layout align-center v-if="forCreate">
                <v-flex class="font-weight-bold px-1" :class="{'order-xs3':reflected}">
                    {{ teams[0].index }}
                </v-flex>
                <v-flex
                        :class="{'order-xs2':reflected}"
                >
                    <v-avatar
                            size="36"
                    >
                        <img v-if="selectedTeam.image.url" :src="selectedTeam.image.url" alt="avatar">
                        <img v-else :src="require('../assets/chess-knight.svg')"/>
                    </v-avatar>
                </v-flex>
                <v-flex>
                    <v-select
                            style="top: -25px;"
                            :items="options"
                            v-model="model[value]"
                            @change="val => emitSelect(val)"
                            clearable
                            hide-details
                            dense
                    />
                </v-flex>
            </v-layout>
            <v-layout align-center v-else>
                <v-flex class="font-weight-bold px-1" :class="{'order-xs3':reflected}">
                    {{ teams[0].index }}
                </v-flex>
                <v-flex
                        :class="{'order-xs2':reflected}"
                >
                    <v-avatar
                            size="36"
                    >
                        <img v-if="teams[0].image" :src="teams[0].image" alt="avatar">
                        <img v-else :src="require('../assets/chess-knight.svg')"/>
                    </v-avatar>
                </v-flex>
                <v-flex>
                    <div class="leaf-node px-3">{{ teams[0].name }}</div>
                </v-flex>
            </v-layout>
        </v-layout>

        <!--        intermediate-->
        <v-layout v-else row class="text-xs-center">
            <v-flex :order-xs2="reflected">
                <bracket-item
                        :model="model"
                        style="margin-bottom: 20px"
                        ref="bracketA"
                        :teams="matchA"
                        :all-teams="allTeams"
                        :reflected="reflected"
                        :for-create="forCreate"
                        :for-manage="forManage"
                        :for-play="forPlay"
                        top/>
                <bracket-item
                        :model="model"
                        ref="bracketB"
                        :teams="matchB"
                        :all-teams="allTeams"
                        :for-create="forCreate"
                        :for-manage="forManage"
                        :for-play="forPlay"
                        :reflected="reflected"
                />
            </v-flex>
            <v-flex :class="bracketClass">
                <v-layout align-center fill-height>
                    <v-flex>
                        <div style="max-height: 32px;">
                            <v-select
                                    style="top: -17px"
                                    class="ma-0 pa-0"
                                    :class="{'align-select-bottom': firstChild}"
                                    v-model="model[value]"
                                    :items="options"
                                    @change="val => emitSelect(val)"
                                    :clearable="forCreate"
                                    hide-details
                                    dense
                            />
                        </div>
                        <!--                                :disabled="forCreate"-->
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    export default {
        name: "BracketItem",
        props: {
            root: {
                type: Boolean,
                default: false
            },
            forCreate: {
                type: Boolean,
                default: false
            },
            forManage: {
                type: Boolean,
                default: false
            },
            forPlay: {
                type: Boolean,
                default: false
            },
            teams: {
                type: Array
            },
            allTeams: {
                type: Array
            },
            reflected: {
                type: Boolean,
                default: false
            },
            firstChild: {
                type: Boolean,
                default: false
            },
            top: {
                type: Boolean,
                default: false
            },
            model: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                matchA: [],
                matchB: [],
                value: "",
                selectedTeam: {image: {}}
            }
        },
        computed: {
            borderStyle() {
                return {
                    [this.reflected ? "border-right" : "border-left"]: "1px solid grey"
                }
            },
            options() {
                let options = []
                if (this.forCreate && this.teams.length === 1) {
                    let selectedTeams = []
                    for (let i = 1; i <= this.allTeams.length; i++) {
                        if (this.model[i] !== "" && this.model[i] !== this.model[this.value]) selectedTeams.push(this.model[i])
                    }
                    this.allTeams.forEach(x => {
                        if (!selectedTeams.some(y => y === x.id)) options.push({text: x.name, value: x.id})
                    })
                } else {
                    let levels = this.value.split(":")
                    let n = levels.length >> 1
                    let selectedTeams = []
                    let child1 = this.model[levels.slice(0, n).join(":")]
                    let child2 = this.model[levels.slice(n).join(":")]
                    if (this.forCreate) {
                        this.allTeams.forEach(x => {
                            options.push({text: x.name, value: x.id})
                        })
                    } else if (child1 !== "" && child1 !== undefined) levels.slice(0, n).forEach(x => {
                        if (parseInt(x) !== child1) selectedTeams.push(parseInt(x))
                    })
                    if (child2 !== "" && child2 !== undefined) levels.slice(n).forEach(x => {
                        if (parseInt(x) !== child2) selectedTeams.push(parseInt(x))
                    })
                    this.teams.forEach(x => {
                        if (!selectedTeams.some(y => y === x.id))
                            options.push({text: x.name, value: x.id})
                    })
                }
                return options
            },
            bracketClass() {
                return this.firstChild || this.root ? {} : {
                    'bracket-left-top': this.reflected && this.top,
                    'bracket-left-bottom': this.reflected && !this.top,
                    'bracket-right-top': !this.reflected && this.top,
                    'bracket-right-bottom': !this.reflected && !this.top
                }
            }
        },
        methods: {
            clear() {
                this.$set(this.model, this.value, "")
                if (this.teams.length > 1) this.emitClear()
            },
            emitSelect(val) {
                let sel = this.allTeams.filter(x => x.id === this.model[this.value])
                if (sel.length) this.selectedTeam = sel[0]
                if (this.teams.length > 2) {
                    this.$refs.bracketA.select(val)
                    this.$refs.bracketB.select(val)
                }
            },
            emitClear() {
                this.$refs.bracketA.clear()
                this.$refs.bracketB.clear()
            },
            select(val) {
                for (let team of this.teams) {
                    if (team.id === val) {
                        this.$set(this.model, this.value, team.id)
                    }
                }
                this.emitSelect(val)
            }
        },
        beforeMount() {
            this.matchA = this.teams.slice(0, this.teams.length / 2)
            this.matchB = this.teams.slice(this.teams.length / 2)
            this.value = this.matchA.map(x => x.id).join(":") + ":" + this.matchB.map(x => x.id).join(":");
            if (this.matchA.length >= 1)
                this.$set(this.model, this.value, "")
            if (this.teams.length === 1) {
                this.value = "" + this.teams[0].id
                if (this.forCreate)
                    this.$set(this.model, this.value, "")
                else
                    this.$set(this.model, this.value, this.teams[0].id)
            }
        }
    }
</script>

<style scoped>
    .bracket-right-top, .bracket-left-top, .bracket-right-bottom, .bracket-left-bottom {
        position: relative;
    }

    .bracket-right-top::after {
        content: " ";
        width: 1px;
        height: 80%;
        background: grey;
        position: absolute;
        right: 0;
        bottom: -30%;
    }

    .bracket-right-bottom::after {
        content: " ";
        width: 1px;
        height: 80%;
        background: grey;
        position: absolute;
        right: 0;
        top: -30%;
    }

    .bracket-left-top::after {
        content: " ";
        width: 1px;
        height: 80%;
        background: grey;
        position: absolute;
        left: 0;
        bottom: -30%;
    }

    .bracket-left-bottom::after {
        content: " ";
        width: 1px;
        height: 80%;
        background: grey;
        position: absolute;
        left: 0;
        top: -30%;
    }

    .align-select-bottom {
        bottom: 10% !important;
    }

    .leaf-node {
        position: relative;
        width: 100%;
        padding-bottom: 30px;
    }

    .leaf-node::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        background: grey;
        left: 0;
        top: 50%;
    }
</style>